import React, { useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { AI_CONVERSATION_TYPE } from 'utils/enum/OpenAIEnum';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from 'components/widgets/tabs/TabPanel';
import AIConversations from 'components/modules/crm/ai/AIConversations';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import ChatBubbleOutlinedIcon from '@material-ui/icons/ChatBubbleOutlined';

const availableTabs = {
    CALLS: 0,
    WEB_CHATS: 1,
};

const AIConversationLayout = () => {
    const [currentTab, setCurrentTab] = useState(availableTabs.CALLS);

    const handleChange = (_, newValue) => setCurrentTab(newValue);
    return (
        <>
            <AppBar color="default" position="static">
                <Tabs value={currentTab} onChange={handleChange} scrollButtons="on" variant="scrollable">
                    <Tab label="AI Calls" icon={<CallOutlinedIcon />} />
                    <Tab label="AI Web Chats" icon={<ChatBubbleOutlinedIcon />} />
                </Tabs>
            </AppBar>
            <TabPanel value={currentTab} index={availableTabs.CALLS}>
                <Helmet
                    defer={false}
                >
                    <title>AI Calls</title>
                </Helmet>
                <AIConversations type={AI_CONVERSATION_TYPE.CALL} />
            </TabPanel>
            <TabPanel value={currentTab} index={availableTabs.WEB_CHATS}>
                <Helmet
                    defer={false}
                >
                    <title>AI Web Chats</title>
                </Helmet>
                <AIConversations type={AI_CONVERSATION_TYPE.WEB_CHAT} />
            </TabPanel>
        </>
    );
};

export default AIConversationLayout;
